import { React, useState, useEffect } from 'react';
import TeamComposition from './TeamComposition';
import TeamSubstitutions from './TeamSubstitutions';
import TeamMissingPlayers from './TeamMissingPlayers';
import TeamCoaches from './TeamCoaches';

const UPDATE_INTERVAL = 30000;

export default function TeamArrangement( {matchId} ) {

    const DATA_URL = `https://46.ds.lsapp.eu/pq_graphql?_hash=dlie2&eventId=${matchId}&projectId=46`;

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        setIsLoading(true);
        const controller = new AbortController();

        const fetchData = async () => {
            try {
                const response = await fetch(DATA_URL, {
                    signal: controller.signal,
                });
                if (!response.ok) {
                    throw new Error(`Error fetching team arrangement data: ${response.status} ${response.statusText}`);
                }
                const data = await response.json();
                setData(data);
            } catch (error) {
                if (error.name === 'AbortError') return;
                console.error('Error fetching team arrangement data:', error);
                setData(null);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData()
        const intervalId = setInterval(fetchData, UPDATE_INTERVAL);

        return () => {
            controller.abort();
            clearInterval(intervalId);
        };

    }, [matchId]);

    if (isLoading) {
        console.log('loading');
        return <div>Загрузка...</div>;
    }

    if (!data) {
        console.log('no data', data);
        return <div>Нет данных</div>;
    }

    return (<div className='team-arrangement'>
        <TeamComposition data={data?.data?.findEventById} />
        <TeamSubstitutions matchId={matchId} playersData={data?.data?.findEventById} />
        <TeamMissingPlayers matchId={matchId} playersData={data?.data?.findEventById} />
        <TeamCoaches data={data?.data?.findEventById} />
    </div>);

}